export default "__VITE_ASSET__Boh5lMAO__"